import {Component, OnInit} from '@angular/core';
import {EnvService} from "../services/env.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {BaseComponent} from "../base/base.component";
import {ActivatedRoute, Router, Params} from '@angular/router';
import {AlertService} from "../services/alert.service";
import {AuthService} from "../services/auth.service";

@Component({
  selector: 'micro-task-findTask',
  templateUrl: './task-findTask.component.html'
})
export class TaskFindTaskComponent {
  taskCarrierId:any;
  taskId:any;
  task:any;

  constructor(protected env: EnvService,
              protected http: HttpClient,
              private route: ActivatedRoute,
              private router:Router,
              private authService:AuthService,
              private alertService:AlertService) {
  }

  find() {
    let params: HttpParams = new HttpParams()
      .set('taskCarrierId', this.taskCarrierId)
      .set('taskId', this.taskId)
    ;

    this.http.get(`${this.env.e.url}/task/omni/tasks/${this.taskId}`, {params: params}).subscribe(
      data => {
        this.task = data as any;
      },
      error => {
        this.alertService.warn("Could not find task");
      }
    );
  }
}
